module.exports = __webpack_public_path__ + "img/addFriend.69af71c1.png";